(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mzs-filter-enhancements"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('main');
  if (!root || root.dataset.mzsFiltersMounted) return;
  root.dataset.mzsFiltersMounted = 'true';
  const collator = new Intl.Collator(document.documentElement.lang || 'nl', {numeric: true, sensitivity: 'base'});
  const normalize = value => value.toLocaleLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[,‚，]/g, '.').replace(/\s+/g, ' ').trim();
  function enhance() {
    const copy = root.querySelector('[data-mzs-filter-copy]');
    if (!copy) return;
    const handle = copy.dataset.collection || '';
    const textOf = group => normalize(group.querySelector('.collection__filter-group-name')?.textContent.replace(/\d+\s*$/, '') || '');
    const isPrice = group => /prijs|price/.test(textOf(group));
    const priority = group => {
      const text = textOf(group);
      if (/prijs|price/.test(text)) return -100;
      if (/beschikbaarheid|availability|voorraad/.test(text)) return 80;
      if (/^(merk|brand|fabrikant)$/.test(text)) return 20;
      if (/jso|frees|frezen/.test(handle)) {
        if (/type.*frees|frees.*type/.test(text)) return 0;
        if (/schacht/.test(text)) return 3;
        if (/diameter/.test(text)) return 4;
        if (/snijlengte/.test(text)) return 5;
      }
      if (/zaag|schijf|boren/.test(handle) && /diameter|asgat|tanden/.test(text)) return /diameter/.test(text)?3:/asgat/.test(text)?4:5;
      if (/dopp|sleutel|ratel|bitset/.test(handle) && /aansluiting|maat dop|maat$/.test(text)) return /aansluiting/.test(text)?3:4;
      if (text === 'producttype') return 45;
      if (/type|soort|categorie/.test(text)) return 10;
      if (/maat|diameter|aansluiting|lengte|vermogen|spanning|capaciteit|schacht|radius|hoek/.test(text)) return 30;
      if (/materiaal|uitvoering/.test(text)) return 40;
      return 50;
    };
    root.querySelectorAll('#desktop-filters-form, #mobile-collection-filters-form').forEach(form => {
      const parents = new Set([...form.querySelectorAll('.collection__filter-group')].map(group=>group.parentElement));
      parents.forEach(parent => {
        if(parent.dataset.mzsOrdered) return;
        parent.dataset.mzsOrdered = 'true';
        const groups = [...parent.children].filter(el=>el.classList.contains('collection__filter-group'));
        const anchor = document.createTextNode('');
        if(groups.length) groups[0].before(anchor);
        groups.sort((a,b)=>priority(a)-priority(b));
        let previous=anchor;
        groups.forEach((group,index)=>{
          previous.after(group);previous=group;
          const options=[...group.querySelectorAll('input[type="checkbox"]')];
          const empty=options.length>0 && options.every(option=>option.disabled&&!option.checked);
          if(empty) group.dataset.mzsEmpty='true';
          const toggle=group.querySelector('button.collection__filter-group-name');
          const panel=group.querySelector('.collection__filter-collapsible');
          if(toggle&&panel&&(index<2||isPrice(group)||options.some(option=>option.checked))&&!empty){
            toggle.setAttribute('aria-expanded','true');panel.setAttribute('aria-hidden','false');panel.style.height='auto';panel.style.overflow='visible';
          }
        });
        anchor.remove();
      });
    });

    root.querySelectorAll('#desktop-filters-form .collection__filter-checkbox-list, #mobile-collection-filters-form .collection__filter-checkbox-list').forEach(list => {
      if (list.dataset.mzsReady) return;
      list.dataset.mzsReady = 'true';
      const group = list.closest('.collection__filter-group');
      const toggle = group?.querySelector('button.collection__filter-group-name');
      if (!toggle) return;
      const title = toggle.childNodes[0]?.textContent.trim() || toggle.textContent.trim();
      const rows = Array.from(list.children);
      const label = row => row.querySelector('label > span')?.textContent.trim() || row.querySelector('label')?.textContent.trim() || '';
      if (/maat|diameter|lengte|schacht|radius|hoek|tanden/i.test(title)) {
        const number = row => parseFloat(normalize(label(row)).replace(/^[^\d]*/, ''));
        rows.sort((a,b) => {
          const prefix = row => normalize(label(row)).match(/^[a-z]+/)?.[0] || '';
          const family = collator.compare(prefix(a), prefix(b));
          if (family) return family;
          const an = number(a), bn = number(b);
          return Number.isFinite(an) && Number.isFinite(bn) && an !== bn ? an - bn : collator.compare(label(a), label(b));
        });
        rows.forEach(row => list.append(row));
      }
      if (!/maat|diameter|lengte|schacht|radius|hoek|tanden/i.test(title)) {
        rows.sort((a,b)=>collator.compare(label(a),label(b)));
      }
      rows.sort((a,b)=>Number(!!a.querySelector('input:disabled'))-Number(!!b.querySelector('input:disabled')));
      rows.forEach(row=>list.append(row));
      const badge = document.createElement('span');
      badge.className = 'mzs-filter-badge';
      function refreshBadge() {
        const count = list.querySelectorAll('input:checked').length;
        badge.textContent = String(count);
        badge.hidden = !count;
        badge.setAttribute('aria-label', count + ' ' + copy.dataset.selected);
      }
      refreshBadge();
      toggle.insertBefore(badge, toggle.querySelector('svg'));
      list.addEventListener('change', refreshBadge);
      if (list.querySelector('input:checked')) {
        toggle.setAttribute('aria-expanded', 'true');
        const panel = list.closest('.collection__filter-collapsible');
        panel.setAttribute('aria-hidden', 'false');
        panel.style.height = 'auto';
        panel.style.overflow = 'visible';
      }
      if (rows.length < 9) return;
      const search = document.createElement('input');
      search.type = 'search';
      search.className = 'mzs-filter-search';
      search.placeholder = copy.dataset.search + ' ' + title.toLocaleLowerCase();
      search.setAttribute('aria-label', search.placeholder);
      search.autocomplete = 'off';
      const empty = document.createElement('p');
      empty.className = 'mzs-filter-empty';
      empty.setAttribute('role', 'status');
      empty.textContent = copy.dataset.empty;
      empty.hidden = true;
      list.before(search);
      list.after(empty);
      search.addEventListener('input', event => {
        event.stopPropagation();
        const query = normalize(search.value);
        let visible = 0;
        rows.forEach(row => {
          row.hidden = !normalize(label(row)).includes(query) && !row.querySelector('input:checked');
          if (!row.hidden) visible++;
        });
        empty.hidden = visible > 0;
      });
      search.addEventListener('change', event => event.stopPropagation());
      search.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); event.stopPropagation(); }
      });
    });
  }
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(record => record.addedNodes.length)) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; enhance(); });
  }).observe(root, {childList: true, subtree: true});
  enhance();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mzs-shop-links"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  var current = event.target.closest('.mzs-other-shops[open]');
  if (!current) return;
  current.open = false;
  current.querySelector('summary').focus();
  event.stopPropagation();
});
document.addEventListener('pointerdown', function(event) {
  document.querySelectorAll('.mzs-other-shops[open]').forEach(function(menu) {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('focusin', function(event) {
  document.querySelectorAll('.mzs-other-shops[open]').forEach(function(menu) {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
  } catch(e) { console.error(e); }
})();

})();
